function socialShare_getNavigationSize() {
  var e = document.getElementsByClassName('navbar vue-block-app  anchors-wrapper')[1];
  if (!e) return 0;
  return e.offsetHeight || 0;
}
function socialShare_getHeaderSize() {
  var e = document.getElementsByTagName('header')[0];
  if (!e) return 0;
  return e.offsetHeight || 0;
}



function socialShare_setVerticalBtn() {
  var btn = document.querySelector('.socialShareBlock');
  if (!btn) return;

  var isClickable = false;
  var vw = window.innerWidth;

  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 100, event);
    };
  }

  function makeButtonsClickable() {
    if (vw < 1200 && !isClickable) {
      btn.querySelector('.socialShareBlock__shareBtns').addEventListener('click', function () {
        this.classList.add('keepOpen');
      });
      btn.querySelector('.closeBtn').addEventListener('click', function (e) {
        btn.querySelector('.socialShareBlock__shareBtns').classList.remove('keepOpen');
        e.stopPropagation();
      });
      isClickable = true;
    }
  }
   makeButtonsClickable();

  window.addEventListener("resize", debounce(function () {
    vw = window.innerWidth;
    makeButtonsClickable();
  }));

  window.addEventListener('scroll', function () {
    if (vw < 1200) {
      handleMobileScrolling();    
    }
    btn.querySelector('.socialShareBlock__shareBtns').classList.remove('keepOpen');
  });


  function handleMobileScrolling() {
    if (window.pageYOffset > socialShare_getHeaderSize()) {
      btn.classList.add('fixedBottom');
    }
    else {
      btn.classList.remove('fixedBottom');
    }
  }
}

window.addEventListener('load', function () {
  socialShare_setVerticalBtn();
});
